import { IDictionaryVersion } from 'APIPackage/DictionariesModule/interfaces/IDictionaryVersion';

/**
 * Ответ get-dictionary-value приходит с 200, но поле value может быть пустой строкой
 * (JSON.parse('') бросает) или уже объектом после res.json() (JSON.parse(object) тоже падает).
 */
export function parseDictionaryVersionValue<T = unknown>(dictionaryVersion: IDictionaryVersion): T {
  const raw = dictionaryVersion.value as unknown;

  if (raw === null || raw === undefined) {
    return (raw as unknown) as T;
  }

  if (typeof raw !== 'string') {
    return raw as T;
  }

  const trimmed = raw.trim();

  if (trimmed === '') {
    return {} as T;
  }

  return JSON.parse(trimmed) as T;
}
